import React from 'react';
import { Route, useLocation, useParams } from 'react-router';
import { PageStateProvider, withPageState } from './page-state.hoc.js';
import { PageData } from './page-data.js';
import { qs } from '../util/qs.js';
import { convertChannel } from '../util/channel.js';
import { defaultChannel } from '../types.js';
const withLegacyHOCs = (component, routeProps) => {
    const PageDataWrappedComponent = (props) => {
        const params = useParams();
        const { pathname, search } = useLocation();
        const queryParams = qs.parse(search.substring(1));
        const { serializeServerSideState = true, ssrCacheTimeSeconds, pageStateRequired = true } = routeProps;
        const { staticContext = {} } = props;
        staticContext.serializeServerSideState = serializeServerSideState;
        staticContext.ssrCacheTimeSeconds = ssrCacheTimeSeconds;
        const matchChannel = params && convertChannel(params.channel);
        const queryChannel = queryParams && queryParams.channel && convertChannel(queryParams.channel);
        const channel = matchChannel || queryChannel || routeProps.channel || defaultChannel;
        const ComponentWithPageState = pageStateRequired ? withPageState(component, { channel }) : component;
        return (React.createElement(React.Fragment, null,
            routeProps.pageData && React.createElement(PageData, Object.assign({ canonical: pathname }, routeProps.pageData)),
            React.createElement(ComponentWithPageState, Object.assign({}, routeProps, props))));
    };
    return PageDataWrappedComponent;
};
const MissingComponent = () => React.createElement("div", null, "PageRoute:please provide a component or children to render");
const PageRoute = (props) => {
    const { pathname } = useLocation();
    const { children } = props;
    if (!children) {
        const WithPageData = withLegacyHOCs(props.component || MissingComponent, props);
        return React.createElement(Route, Object.assign({}, props, { component: WithPageData }));
    }
    return (React.createElement(Route, Object.assign({}, props),
        React.createElement(PageStateProvider, { channel: props.channel },
            props.pageData && React.createElement(PageData, Object.assign({ canonical: pathname }, props.pageData)),
            children)));
};
export { PageRoute };
